"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_components_1 = require("styled-components");

var scenario_node_view_styles_1 = require("../scenario-node-view/scenario-node-view.styles");

var text_scenario_node_styles_1 = require("./text-scenario-node.styles");

var scenario_node_footer_button_box_component_1 = __importDefault(require("../scenario-node-footer-button-box/scenario-node-footer-button-box.component"));

var TextScenarioNode = function TextScenarioNode(_ref) {
  var node = _ref.node,
      _ref$design = _ref.design,
      headerBackColor = _ref$design.headerBackColor,
      headerTextColor = _ref$design.headerTextColor,
      bodyBackColor = _ref$design.bodyBackColor,
      bodyTextColor = _ref$design.bodyTextColor,
      preButtonColor = _ref$design.preButtonColor,
      initButtonColor = _ref$design.initButtonColor,
      _ref$scale = _ref.scale,
      scale = _ref$scale === void 0 ? 1 : _ref$scale;
  var header = node.header,
      options = node.options;
  return react_1.default.createElement(styled_components_1.ThemeProvider, {
    theme: scenario_node_view_styles_1.initNodeTheme(scale)
  }, react_1.default.createElement(text_scenario_node_styles_1.StyledTextNodeDiv, {
    "data-meta": "text-scenario-node"
  }, react_1.default.createElement(text_scenario_node_styles_1.StyledTextNodeHeaderDiv, {
    headerBackColor: headerBackColor,
    headerTextColor: headerTextColor
  }, react_1.default.createElement(text_scenario_node_styles_1.StyledWordBreakP, null, header)), react_1.default.createElement(text_scenario_node_styles_1.StyledTextNodeBodyDiv, {
    bodyBackColor: bodyBackColor,
    bodyTextColor: bodyTextColor
  }, options.length > 0 ? react_1.default.createElement(text_scenario_node_styles_1.StyledTextOptionsUl, null, options.map(function (option, i) {
    return react_1.default.createElement(text_scenario_node_styles_1.StyledTextOptionLi, {
      key: i
    }, react_1.default.createElement(text_scenario_node_styles_1.StyledWordBreakP, null, option.label));
  })) : react_1.default.createElement(text_scenario_node_styles_1.StyledEmptyOptionP, null, "\u9078\u629E\u80A2\u306A\u3057"), react_1.default.createElement(scenario_node_footer_button_box_component_1.default, {
    preButtonColor: preButtonColor,
    initButtonColor: initButtonColor
  }))));
};

exports.default = TextScenarioNode;